import axios from 'axios'
import { getGaClientId, getGaSessionId } from '@/utils/analytics'

const token = localStorage.getItem('token')
const Api = axios.create({
  baseURL: process.env.VUE_APP_endpoint,
})

Api.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
if (token != '') {
  Api.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

// Attach GA4 client/session ids to checkout POSTs so the server-side `purchase`
// (fired from the PAID webhook) stitches to the originating GA session.
// Single injection point — the guest checkouts (checkout-webinar/-workshop) and the
// logged-in ones (transaksi/new-invoice, transaksi/beli_paket).
Api.interceptors.request.use((config) => {
  try {
    const url = config.url || ''
    if (/checkout-(webinar|workshop)|transaksi\/(new-invoice|beli_paket)/.test(url) && config.data && typeof config.data === 'object') {
      config.data.ga_client_id = getGaClientId()
      config.data.ga_session_id = getGaSessionId()
    }
  } catch (e) {
    /* never block checkout */
  }
  return config
})

// Session invalidation: JwtMiddleware returns {status:'Token is Invalid'|...} (HTTP 200)
// when the token no longer matches the account's password hash — i.e. the password was
// reset/changed on another device. Detect that, clear the local session and bounce to
// login so a stale tab (e.g. after someone reset the password elsewhere) can't linger.
const INVALID_TOKEN_STATUSES = [
  'Token is Invalid',
  'Token is Expired',
  'Authorization Token not found',
]
Api.interceptors.response.use((response) => {
  try {
    const status = response && response.data && response.data.status
    if (typeof status === 'string' && INVALID_TOKEN_STATUSES.includes(status)) {
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      localStorage.removeItem('menu')
      delete Api.defaults.headers.common['Authorization']
      const path = window.location.pathname
      // avoid a redirect loop on public/auth pages
      if (!/^\/(login|register|forget-password|forgot-password|$)/.test(path)) {
        window.location.assign('/login')
      }
    }
  } catch (e) {
    /* never break a normal response */
  }
  return response
})

export default Api
